export interface CompareTableItemContent {
  fieldName: string;
  content: string;
  cssClass?: string;
}
